import { t } from "@/i18n-js/instance";
import { Avatar } from "@circle-react/components/SettingsApp/Workflows/components/Avatar";
import { Typography } from "@circle-react-uikit/Typography";
import { PaywallName } from "./PaywallName";

export interface CancelSubscriptionApiParams {
  paywall_id: number;
}

export interface HistoryDetailViewPaywallProps {
  apiParams: CancelSubscriptionApiParams;
  body: {
    community_member_id: number;
  };
  url: string;
}

export const HistoryDetailViewPaywall = ({
  body,
  apiParams,
}: HistoryDetailViewPaywallProps) => {
  const { community_member_id: communityMemberId } = body;
  const { paywall_id: paywallId } = apiParams;

  return (
    <>
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.paywall")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          <PaywallName id={paywallId} />
        </div>
      </div>
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.member")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          <Avatar communityMemberId={communityMemberId} />
        </div>
      </div>
    </>
  );
};
